/* eslint-disable */
// @ts-nocheck
import { BytesLike, BigNumber, BigNumberish } from 'ethers';
import { contract, Call, Send, AddressLike, Contract } from '@enzymefinance/ethers';



// prettier-ignore
export interface ITestGsnForwarder extends Contract<ITestGsnForwarder> {
  getNonce: Call<(_sender: AddressLike) => BigNumber, ITestGsnForwarder>
  'getNonce(address)': Call<(_sender: AddressLike) => BigNumber, ITestGsnForwarder>
}

let ITestGsnForwarderBytecode: string | undefined = undefined;
if (typeof window === 'undefined') {
  ITestGsnForwarderBytecode = '0x';
}

// prettier-ignore
export const ITestGsnForwarder = contract<ITestGsnForwarder>(ITestGsnForwarderBytecode)`
  function getNonce(address _sender) view returns (uint256 nonce_)
`;